<template>
  <v-container align-center class="pl-0">
    <v-snackbar v-model="snackbar" :color="snackbarStatus" :timeout="2500">
      {{ snackbarText }}
      <v-btn
        :color="snackbarStatus === 'error' ? 'white' : 'pink'"
        text
        @click="snackbar = false"
        >Cerrar</v-btn
      >
    </v-snackbar>
    <v-snackbar v-model="getError.error" color="error" :timeout="3500">{{
      getError.errorMessage
    }}</v-snackbar>
    <SnackbarStatusFAB
      :success.sync="successFAB"
      :error.sync="errorFAB"
      :successMessage.sync="successFABMessage"
      :errorMessage.sync="errorFABMessage"
      @load-draft="onLoadSelectedDraft"
    />
    <v-speed-dial right bottom fixed>
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab"> mdi-close </v-icon>
          <v-icon v-else large> mdi-progress-wrench </v-icon>
        </v-btn>
      </template>

      <v-btn fab dark small :color="color">
        <v-icon>mdi-information</v-icon>
      </v-btn>
      <v-btn fab dark small color="indigo" @click="onLoadDrafts">
        <v-icon>mdi-content-save-move</v-icon>
      </v-btn>
      <v-btn fab dark small color="green" @click="onSaveDraft">
        <v-icon>mdi-content-save-all</v-icon>
      </v-btn>
      <v-btn fab dark small color="red" v-on:click.native="resetForm()">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-card>
      <v-card-title class="headline">
        Información de Nueva Propuesta
        <div class="flex-grow-1"></div>
        <v-slide-x-reverse-transition>
          <v-tooltip
            :color="tooltipColor"
            :dark="tooltipDark"
            v-if="formHasErrors"
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn icon class="my-0" v-on="on" :color="color">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>{{ tooltipMsg }}</span>
          </v-tooltip>
        </v-slide-x-reverse-transition>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form v-model="valid" ref="form">
          <v-divider></v-divider>
          <div class="mt-2 title black--text">Del Puesto</div>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="propuesta.nombrePuesto"
                label="Título del Puesto Ofrecido"
                required
                :counter="150"
                filled
                :color="color"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="propuesta.areaEmpresa"
                label="Área Funcional del Puesto Ofrecido"
                required
                :counter="150"
                filled
                :color="color"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6" class="d-flex justify-center">
              <v-select
                :items="getUbication.paises"
                item-value="codigo"
                item-text="nombrePais"
                required
                filled
                label="País de Ubicación"
                v-model="propuesta.pais"
                @change="onChangePais"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="propuesta.pais == 'PER'">
              <v-select
                v-model="propuesta.departamento"
                label="Ubicación de Departamento"
                :items="getUbication.departamentos"
                item-text="departamento"
                item-value="ubigeo"
                filled
                required
                :color="color"
                @change="obtenerProvincia"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="propuesta.pais == 'PER'">
            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="propuesta.provincia"
                label="Ubicación de Provincia"
                :items="listaProvincias"
                item-text="provincia"
                item-value="ubigeo"
                filled
                required
                :color="color"
                :loading="fetching"
                @change="obtenerDistrito"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="propuesta.distrito"
                label="Ubicación del Distrito"
                :items="listaDistritos"
                item-text="distrito"
                item-value="ubigeo"
                filled
                required
                :loading="fetching"
                :color="color"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="propuesta.pais == 'PER'">
            <v-col cols="12" sm="12">
              <v-text-field
                v-model="propuesta.direccionTrabajo"
                label="Dirección del Lugar"
                filled
                required
                :color="color"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-textarea
                v-model="propuesta.descripcionTrabajo"
                label="Descripción de la Propuesta"
                :counter="500"
                hint="*Es recomendable que el contenido sea breve"
                persistent-hint
                filled
                :color="color"
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-textarea
                v-model="propuesta.funciones"
                label="Funciones a desarrollar"
                :counter="400"
                hint="Las funciones deben estar separadas por un salto de línea"
                persistent-hint
                filled
                :color="color"
                rows="4"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-select
                v-model="propuesta.contrato.tipo"
                :items="ItemstipoContrato"
                item-text="name"
                item-value="value"
                label="Tipo de Contrato Ofrecido"
                filled
                required
                :color="color"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="propuesta.contrato.tiempo"
                label="Duración de Contrato Ofrecido"
                hint="*Usa números para llenar este campo"
                persistent-hint
                :rules="ruleNumber"
                filled
                required
                :color="color"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-select
                v-model="propuesta.contrato.unidad"
                :items="itemsUnidad"
                item-text="name"
                item-value="value"
                label="Unidad de Duración de Contrato"
                filled
                required
                :color="color"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="3">
              <v-select
                v-model="propuesta.horario.tipo"
                :items="itemsHorarioTipo"
                item-text="name"
                item-value="value"
                label="Tipo de Horario"
                filled
                required
                :color="color"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field
                v-model="propuesta.horario.horasSemanales"
                :rules="ruleNumber"
                label="# de Horas Semanales"
                filled
                :color="color"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="propuesta.horario.descripcion"
                label="Descripción"
                hint="Este campo no es obligatorio"
                persistent-hint
                filled
                :color="color"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="propuesta.cantidadVacantes"
                label="Número de Vacantes"
                filled
                :rules="ruleNumber"
                :value="1"
                :color="color"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-checkbox
                :color="color"
                v-model="propuesta.requiereExperiencia"
                label="Requiere Experiencia"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-checkbox
                :color="color"
                v-model="propuesta.trabajoEnExtranjero"
                label="Posibilidad de Trabajo en Extranjero"
              ></v-checkbox>
            </v-col>
          </v-row>
          <template v-if="propuesta.requiereExperiencia">
            <v-divider class="mb-4"></v-divider>
            <v-row class="d-flex justify-end">
              <v-btn text @click="agregarRowExperiencia">
                <v-icon left color="red">mdi-plus-circle</v-icon>Agregar
                Experiencia
              </v-btn>
            </v-row>
            <template v-for="(item, index) in propuesta.experiencia">
              <v-row
                class="grey lighten-4 d-flex flex-row align-center"
                :key="`exp${index}`"
              >
                <v-col cols="12" sm="1">
                  <p class="font-weight-black headline d-flex justify-center">
                    {{ index + 1 }}.
                  </p>
                </v-col>
                <v-col cols="12" sm="12" md="4" class="d-flex my-auto pb-0">
                  <v-text-field
                    v-model="item.detalle"
                    label="Detalle de la Experiencia"
                    filled
                    required
                    :color="color"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="d-flex my-auto pb-0">
                  <v-text-field
                    v-model="item.tiempo"
                    label="Tiempo de la Experiencia"
                    :rules="ruleNumber"
                    filled
                    required
                    :color="color"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="d-flex my-auto pb-0">
                  <v-select
                    v-model="item.unidad"
                    :items="itemsUnidad"
                    item-text="name"
                    item-value="value"
                    label="Unidad de Duración de Experiencia"
                    filled
                    required
                    :color="color"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                  <v-btn icon color="red" @click="quitarRowExperiencia(index)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <v-divider class="mt-4"></v-divider>
          </template>
          <v-row justify="center">
            <v-col cols="12" sm="12" md="3" class="mt-4">
              <p class="title black--text">Fecha Límite</p>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-dialog
                ref="dialogFechaValidez"
                v-model="modalFechaValidez"
                :return-value.sync="propuesta.fechaValidez"
                width="290px"
                class="flex-shrink-0 flex-grow-0"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedFechaValidezFormateada"
                    label="Fecha de Inicio"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    class="mx-4"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="propuesta.fechaValidez"
                  scrollable
                  locale="es"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalFechaValidez = false"
                    >Cancelar</v-btn
                  >
                  <v-btn text color="primary" @click="actualizarFechaValidez()"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-dialog
                ref="dialogFechaVencimiento"
                v-model="modalFechaVencimiento"
                :return-value.sync="propuesta.fechaVencimiento"
                width="290px"
                class="flex-shrink-0 flex-grow-0"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedFechaVencimientoFormateada"
                    label="Fecha de Vencimiento"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    class="mx-4"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="propuesta.fechaVencimiento"
                  scrollable
                  locale="es"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="modalFechaVencimiento = false"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="actualizarFechaVencimiento()"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <div class="mt-2 title black--text">De los Postulantes</div>
          <v-row>
            <v-col cols="12" sm="12">
              <v-autocomplete
                v-model="propuesta.especialidades"
                :items="getListaCarreras"
                item-text="nombreEspecialidad"
                item-value="codigoEspecialidad"
                label="Carreras Seleccionadas para el Puesto"
                multiple
                filled
                :color="color"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggle">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          propuesta.especialidades.length > 0 ? 'red' : ''
                        "
                        >{{ icon }}</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Seleccionar Todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template
                  v-slot:selection="{ item, index }"
                  v-if="
                    propuesta.especialidades.length == getListaCarreras.length
                  "
                >
                  <v-chip v-if="index === 0">
                    <span>Todas las Carreras Seleccionadas</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >({{ propuesta.especialidades.length - 1 }})
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" :md="calcColsForm1">
              <v-select
                v-model="propuesta.gradoAcademico"
                :items="niveles"
                label="Grado Académico"
                multiple
                filled
                :color="color"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" :md="calcColsForm1">
              <v-select
                v-model="propuesta.ordenMerito"
                :items="meritos"
                item-text="text"
                item-value="value"
                label="Órden de Mérito"
                filled
                :color="color"
              ></v-select>
            </v-col>
            <v-col
              v-if="propuesta.gradoAcademico.indexOf(niveles[0]) != -1"
              cols="12"
              sm="12"
              md="4"
            >
              <v-text-field
                v-model="propuesta.cicloRelativo"
                label="Ciclo Relativo del Estudiante"
                hint="Ingresa el ciclo Relativo Mínimo del Estudiante"
                :rules="ruleNumber"
                persistent-hint
                filled
                :color="color"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <div class="mt-2 title black--text">Conocimientos e Idiomas</div>
          <v-row>
            <v-col cols="12" sm="12">
              <div class="d-flex justify-end">
                <v-btn text @click="agregarRowConocimiento">
                  <v-icon left color="red">mdi-plus-circle</v-icon>Agregar
                  Conocimiento
                </v-btn>
              </div>
              <div class="px-3" v-if="propuesta.conocimientos.length">
                <template v-for="(item, index) in propuesta.conocimientos">
                  <v-row
                    :key="`conocim${index}`"
                    class="grey lighten-4 d-flex flex-row align-center mt-2"
                  >
                    <v-col cols="12" sm="1">
                      <p
                        class="font-weight-black headline d-flex justify-center"
                      >
                        {{ index + 1 }}.
                      </p>
                    </v-col>
                    <v-col cols="12" sm="6" class="pb-0">
                      <v-text-field
                        v-model="item.descripcion"
                        label="Descripción del Conocimiento"
                        filled
                        required
                        :color="color"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" class="pb-0">
                      <v-select
                        v-model="item.tipo"
                        :items="itemsTipo"
                        item-text="name"
                        item-value="value"
                        label="Tipo de Requerimiento"
                        filled
                        required
                        :color="color"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="1">
                      <v-btn
                        icon
                        color="red"
                        @click="quitarRowConocimiento(index)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </div>
              <div v-else class="d-flex justify-center mt-4">
                <p>Aquí aparecerán los conocimientos agregados</p>
              </div>
              <v-divider class="mt-4"></v-divider>
            </v-col>

            <v-col cols="12" sm="12">
              <v-select
                v-model="idiomaSelec"
                :items="idiomaItems"
                label="Idiomas"
                hint="No seleccionar si no es necesario. Seleccionar 3 como máximo"
                persistent-hint
                multiple
                filled
                :color="color"
                :menu-props="{ offsetY: true, closeOnContentClick: true }"
              ></v-select>

              <v-container fluid v-if="idiomaSelec.length" align-center>
                <v-row
                  v-for="(idiom, i) in idiomaSelec"
                  :key="i"
                  align="start"
                  class="ma-0"
                >
                  <v-col cols="1" sm="1" md="1" class="mt-4">
                    <v-icon :color="color">mdi-arrow-right-bold-outline</v-icon>
                  </v-col>
                  <v-col cols="4" sm="3" md="3" class="mt-3">
                    <p class="headline black--text">{{ idiom }}</p>
                  </v-col>
                  <v-col cols="7" sm="3" md="8">
                    <v-select
                      v-model="nivelIdiomaSelec[i]"
                      :items="nivelIdioma"
                      item-text="text"
                      item-value="value"
                      label="Nivel Requerido"
                      filled
                      dense
                      :color="color"
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <div class="mt-2 title black--text">Beneficios</div>
          <v-row justify="center" align="center">
            <v-col cols="12" sm="3" class="mx-auto">
              <p class="subtitle black--text">Sobre el salario</p>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-select
                v-model="propuesta.salario.moneda"
                :items="itemsSalarioMoneda"
                item-text="name"
                item-value="value"
                label="Tipo de Moneda"
                filled
                required
                :color="color"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-select
                v-model="propuesta.salario.tipo"
                :items="itemsSalarioTipo"
                item-text="name"
                item-value="value"
                label="Tipo de Salario"
                filled
                :color="color"
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            align="center"
            v-if="propuesta.salario.tipo != 'NO DEFINIDO'"
          >
            <v-col cols="12" sm="3" class="mx-auto">
              <p class="subtitle black--text">Monto Ofrecido por Contrato</p>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="propuesta.salario.valor.min"
                :label="propuesta.salario.tipo == 'RANGO' ? 'Desde' : 'Salario'"
                placeholder="0.00"
                filled
                :color="color"
                :prefix="getPrefix"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
              v-if="propuesta.salario.tipo == 'RANGO'"
            >
              <v-text-field
                v-model="propuesta.salario.valor.max"
                label="Hasta"
                placeholder="0.00"
                filled
                :color="color"
                :prefix="getPrefix"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <!-- <v-col cols="9" class="pb-0">
              <p
                class="subtitle-1 black--text ma-0"
              >Se recomienda visualizar el resultado de la propuesta mediante el botón inferior de "Vista Previa".</p>
            </v-col>-->
          </v-row>
          <v-divider class="my-2"></v-divider>
        </v-form>
      </v-card-text>
      <v-card-actions class="pb-4">
        <div class="flex-grow-1"></div>
        <!-- <v-btn color="blue-grey white--text">
          Vista Previa
          <v-icon right dark class="mx-1">mdi-eye</v-icon>
        </v-btn>-->
        <v-btn color="success" large :loading="fetching" @click="submitTrabajo"
          >Publicar</v-btn
        >
        <div class="flex-grow-1"></div>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { setTimeout } from "timers";
import { StorageService } from "@/services/storage.service";

export default {
  name: "crearPropuesta",

  components: {
    SnackbarStatusFAB: () =>
      import("@/components/company/messageBox/SnackbarStatusFAB.vue")
  },

  data: (vm) => ({
    propuesta: {
      nombrePuesto: "",
      areaEmpresa: "",
      pais: "PER",
      distrito: "",
      provincia: "",
      departamento: "",
      direccionTrabajo: "",
      descripcionTrabajo: "",
      experiencia: [{ detalle: "", tiempo: 0, unidad: "" }],
      funciones: "",
      contrato: {},
      cantidadVacantes: "",
      requiereExperiencia: true,
      trabajoEnExtranjero: false,
      fechaValidez: new Date(new Date().setHours(-5))
        .toISOString()
        .substr(0, 10),
      fechaVencimiento: new Date(new Date().setHours(24))
        .toISOString()
        .substr(0, 10),
      especialidades: [],
      cicloRelativo: "",
      gradoAcademico: [],
      ordenMerito: "",
      conocimientos: [],
      reqAdicionales: "",
      salario: { valor: {} },
      horario: {},
      moneda: "soles",
      mostrarMonto: true,
      montoDesde: "",
      montoHasta: "",
      otrosBenef: ""
    },
    idiomaSelec: [],
    nivelIdiomaSelec: [],
    ruleNumber: [
      (v) => !!v || "El valor es requerido",
      (v) => (v && !isNaN(v)) || "El valor tiene que ser un número"
    ],
    tooltipMsg: "¿Limpiar Formulario?",
    tooltipColor: "",
    tooltipDark: false,
    color: "blue",
    valid: false,
    formHasErrors: true,
    checkbox: true,
    ItemstipoContrato: [
      { name: "Definida", value: "DEFINIDO" },
      { name: "Indefinida", value: "INDEFINIDO" }
    ],
    itemsUnidad: [
      { name: "Meses", value: "MESES" },
      { name: "Años", value: "AÑOS" }
    ],
    itemsTipo: [
      { name: "Requerido", value: "REQUERIDO" },
      { name: "Deseable", value: "DESEABLE" }
    ],
    itemsSalarioMoneda: [
      { name: "Soles", value: "SOL" },
      { name: "Dólares", value: "DOLAR" },
      { name: "Euros", value: "EURO" }
    ],
    itemsSalarioTipo: [
      { name: "Salario Fijo", value: "FIJO" },
      { name: "Rango de Salario", value: "RANGO" },
      { name: "Por Definir", value: "NO DEFINIDO" }
    ],
    itemsHorarioTipo: [
      { name: "Horario Flexible", value: "FLEXIBLE" },
      { name: "Horario Fijo", value: "FIJO" }
    ],
    ubicaciones: [
      "Perú - Lima",
      "Perú - Trujillo",
      "Perú - Huancayo",
      "Perú - Cusco"
    ],
    niveles: [
      "Estudiante",
      "Egresado",
      "Bachiller",
      "Licenciado",
      "Titulado",
      "Maestría",
      "Doctorado",
      "Ph. D."
    ],
    meritos: [
      { text: "Cualquiera", value: "CUALQUIERA" },
      { text: "Tercio Superior", value: "TERCIO" },
      { text: "Quinto Superior", value: "QUINTO" },
      { text: "Décimo Superior", value: "DECIMO" }
    ],

    nivelesAcad: [
      "Cualquiera",
      "1er Ciclo",
      "2do Ciclo",
      "3er Ciclo",
      "4to Ciclo",
      "5to Ciclo",
      "6to Ciclo",
      "7mo Ciclo",
      "8vo Ciclo",
      "9no Ciclo",
      "10mo Ciclo"
    ],

    idiomaItems: [
      "Inglés",
      "Francés",
      "Italiano",
      "Portugués",
      "Japonés",
      "Chino Mandarin",
      "Alemán"
    ],

    nivelIdioma: [
      { text: "Básico", value: "BASICO" },
      { text: "Intermedio", value: "INTERMEDIO" },
      { text: "Avanzado", value: "AVANZADO" }
    ],
    date1: new Date(new Date().setHours(-5)).toISOString().substr(0, 10),
    date2: new Date(new Date().setHours(-5)).toISOString().substr(0, 10),
    dateValidez: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateVencimiento: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    snackbarText: "",
    snackbar: false,
    snackbarColor: "",
    snackbarStatus: "",
    modalFechaVencimiento: false,
    modalFechaValidez: false,

    listaProvincias: [
      {
        ubigeo: "1405",
        provincia: "HUAURA"
      },
      {
        ubigeo: "1410",
        provincia: "OYON"
      },
      {
        ubigeo: "1408",
        provincia: "HUARAL"
      },
      {
        ubigeo: "1407",
        provincia: "YAUYOS"
      },
      {
        ubigeo: "1401",
        provincia: "LIMA"
      },
      {
        ubigeo: "1402",
        provincia: "CAJATAMBO"
      },
      {
        ubigeo: "1406",
        provincia: "HUAROCHIRI"
      },
      {
        ubigeo: "1409",
        provincia: "BARRANCA"
      },
      {
        ubigeo: "1403",
        provincia: "CANTA"
      },
      {
        ubigeo: "1404",
        provincia: "CAÑETE"
      }
    ],
    listaDistritos: [
      {
        ubigeo: "140142",
        distrito: "LOS OLIVOS"
      },
      {
        ubigeo: "140107",
        distrito: "CHACLACAYO"
      },
      {
        ubigeo: "140138",
        distrito: "SAN LUIS"
      },
      {
        ubigeo: "140141",
        distrito: "VILLA EL SALVADOR"
      },
      {
        ubigeo: "140130",
        distrito: "SANTIAGO DE SURCO"
      },
      {
        ubigeo: "140108",
        distrito: "CHORRILLOS"
      },
      {
        ubigeo: "140102",
        distrito: "ANCON"
      },
      {
        ubigeo: "140136",
        distrito: "SAN JUAN DE MIRAFLORES"
      },
      {
        ubigeo: "140101",
        distrito: "LIMA"
      },
      {
        ubigeo: "140106",
        distrito: "COMAS"
      },
      {
        ubigeo: "140134",
        distrito: "INDEPENDENCIA"
      },
      {
        ubigeo: "140110",
        distrito: "LA MOLINA"
      },
      {
        ubigeo: "140133",
        distrito: "JESUS MARIA"
      },
      {
        ubigeo: "140109",
        distrito: "LA VICTORIA"
      },
      {
        ubigeo: "140111",
        distrito: "LINCE"
      },
      {
        ubigeo: "140103",
        distrito: "ATE"
      },
      {
        ubigeo: "140104",
        distrito: "BREÑA"
      },
      {
        ubigeo: "140135",
        distrito: "EL AGUSTINO"
      },
      {
        ubigeo: "140113",
        distrito: "LURIN"
      },
      {
        ubigeo: "140115",
        distrito: "MIRAFLORES"
      },
      {
        ubigeo: "140120",
        distrito: "PUNTA HERMOSA"
      },
      {
        ubigeo: "140140",
        distrito: "SAN BORJA"
      },
      {
        ubigeo: "140121",
        distrito: "PUNTA NEGRA"
      },
      {
        ubigeo: "140124",
        distrito: "SAN ISIDRO"
      },
      {
        ubigeo: "140137",
        distrito: "SAN JUAN DE LURIGANCHO"
      },
      {
        ubigeo: "140129",
        distrito: "SANTA ROSA"
      },
      {
        ubigeo: "140105",
        distrito: "CARABAYLLO"
      },
      {
        ubigeo: "140112",
        distrito: "LURIGANCHO"
      },
      {
        ubigeo: "140131",
        distrito: "SURQUILLO"
      },
      {
        ubigeo: "140143",
        distrito: "SANTA ANITA"
      },
      {
        ubigeo: "140118",
        distrito: "PUCUSANA"
      },
      {
        ubigeo: "140122",
        distrito: "RIMAC"
      },
      {
        ubigeo: "140132",
        distrito: "VILLA MARIA DEL TRIUNFO"
      },
      {
        ubigeo: "140116",
        distrito: "PACHACAMAC"
      },
      {
        ubigeo: "140125",
        distrito: "BARRANCO"
      },
      {
        ubigeo: "140123",
        distrito: "SAN BARTOLO"
      },
      {
        ubigeo: "140127",
        distrito: "SAN MIGUEL"
      },
      {
        ubigeo: "140126",
        distrito: "SAN MARTIN DE PORRES"
      },
      {
        ubigeo: "140114",
        distrito: "MAGDALENA DEL MAR"
      },
      {
        ubigeo: "140119",
        distrito: "PUENTE PIEDRA"
      },
      {
        ubigeo: "140128",
        distrito: "SANTA MARIA DEL MAR"
      },
      {
        ubigeo: "140139",
        distrito: "CIENEGUILLA"
      },
      {
        ubigeo: "140117",
        distrito: "PUEBLO LIBRE"
      }
    ],

    fab: false,

    successFAB: false,
    errorFAB: false,
    successFABMessage: "Realizado",
    errorFABMessage: "Error"
  }),

  computed: {
    likesAllItems: function () {
      return (
        this.propuesta.especialidades.length === this.getListaCarreras.length
      );
    },

    likesSomeItem: function () {
      return this.propuesta.especialidades.length > 0 && !this.likesAllItems;
    },

    icon: function () {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    calcColsForm1: function () {
      if (this.propuesta.gradoAcademico.indexOf(this.niveles[0]) != -1)
        return "4";
      return "6";
    },

    getPrefix: function () {
      switch (this.propuesta.salario.moneda) {
        case "SOL":
          return "S/";
          break;

        case "DOLAR":
          return "$";
          break;

        case "EURO":
          return "€";
          break;

        default:
          return "";
          break;
      }
    },

    computedFechaValidezFormateada: function () {
      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };
      return new Date(
        new Date(this.propuesta.fechaValidez).setHours(24)
      ).toLocaleDateString("es-PE", options);
    },

    computedFechaVencimientoFormateada: function () {
      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };

      return new Date(
        new Date(this.propuesta.fechaVencimiento).setHours(24)
      ).toLocaleDateString("es-PE", options);
    },

    ...mapGetters("user", [
      "getUbication",
      "getListaCarreras",
      "getError",
      "fetching"
    ])
  },

  methods: {
    agregarRowExperiencia() {
      this.propuesta.experiencia.push({ detalle: "", tiempo: 0, unidad: "" });
    },

    quitarRowExperiencia(index) {
      this.propuesta.experiencia.splice(index, 1);
    },

    agregarRowConocimiento() {
      this.propuesta.conocimientos.push({ tipo: "", descripcion: "" });
    },

    quitarRowConocimiento(index) {
      this.propuesta.conocimientos.splice(index, 1);
    },

    resetForm() {
      const vm = this;
      vm.propuesta = {
        nombrePuesto: "",
        areaEmpresa: "",
        pais: "PER",
        distrito: "",
        provincia: "",
        departamento: "",
        direccionTrabajo: "",
        descripcionTrabajo: "",
        experiencia: [{ detalle: "", tiempo: 0, unidad: "" }],
        funciones: "",
        contrato: {},
        cantidadVacantes: "",
        requiereExperiencia: true,
        trabajoEnExtranjero: false,
        fechaValidez: new Date(new Date().setHours(-5))
          .toISOString()
          .substr(0, 10),
        fechaVencimiento: new Date(new Date().setHours(24))
          .toISOString()
          .substr(0, 10),
        especialidades: [],
        cicloRelativo: "",
        gradoAcademico: [],
        ordenMerito: "",
        conocimientos: [],
        reqAdicionales: "",
        salario: { valor: {} },
        horario: {},
        moneda: "soles",
        mostrarMonto: true,
        montoDesde: "",
        montoHasta: "",
        otrosBenef: ""
      };

      vm.tooltipColor = "green";
      vm.tooltipMsg = "¡Formulario Limpio!";
      vm.tooltipDark = true;
      setTimeout(function () {
        vm.tooltipColor = "";
        vm.tooltipMsg = "¿Limpiar Formulario?";
        vm.tooltipDark = false;
      }, 2000);
    },

    setSuccessStatus(isSuccess, successMessage) {
      this.successFAB = isSuccess;
      this.successFABMessage = successMessage;
    },

    setErrorStatus(isError, errorMessage) {
      this.errorFAB = isError;
      this.errorFABMessage = errorMessage;
    },

    toggle() {
      if (this.likesAllItems) {
        this.propuesta.especialidades = [];
      } else {
        this.propuesta.especialidades = this.getListaCarreras
          .slice()
          .map((i) => i.codigoEspecialidad);
      }
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    actualizarFechaVencimiento() {
      this.$refs.dialogFechaVencimiento.save(this.propuesta.fechaVencimiento);
    },

    actualizarFechaValidez() {
      this.$refs.dialogFechaValidez.save(this.propuesta.fechaValidez);
    },

    async submitTrabajo() {
      let { ...body } = this.propuesta;
      if (!body.requiereExperiencia) body.experiencia = [];
      if (body.salario.tipo == "FIJO")
        body.salario.valor = body.salario.valor.min;
      let idiomas = [];
      for (let i = 0; i < this.idiomaSelec.length; i++) {
        idiomas.push({
          idioma: this.idiomaSelec[i],
          nivel: this.nivelIdiomaSelec[i]
        });
      }
      body.ubigeo = body.pais == "PER" ? body.distrito : "";
      body.idiomas = idiomas;
      body.funciones = body.funciones.split("\n");

      console.log(body);

      let response = await this.crearTrabajo(body);

      if (response.success) {
        this.snackbar = true;
        this.snackbarStatus = "Success";
        this.snackbarText = response.message;
      }
    },

    async obtenerProvincia() {
      if (this.propuesta.departamento != "") {
        let response = await this.fetchProvincia(this.propuesta.departamento);
        this.listaProvincias = response;
      }
    },

    async obtenerDistrito() {
      if (this.propuesta.provincia != "") {
        let response = await this.fetchDistritos(this.propuesta.provincia);
        this.listaDistritos = response;
      }
    },

    onChangePais() {
      if (this.propuesta.pais != "") {
        this.propuesta.departamento = "";
        this.propuesta.provincia = "";
        this.propuesta.direccionTrabajo = "";
      }
    },

    onLoadDrafts() {
      this.setDraftsPropuestaDialog(true);
    },

    onSaveDraft() {
      if (!this.propuesta.nombrePuesto) {
        this.setErrorStatus(
          true,
          "El Título del Puesto Ofrecido es necesario para guardar el borrador"
        );
        return;
      }
      let draftData = this.getRawObject(this.propuesta);
      draftData.fechaGuardado = new Date().toISOString();
      let draftsList = StorageService.getDrafts();
      draftsList = draftsList ? JSON.parse(draftsList) : [];
      let previousSaveIndex = draftsList
        ? draftsList.findIndex((d) => d.nombrePuesto === draftData.nombrePuesto)
        : -1;
      if (previousSaveIndex > -1) {
        draftsList[previousSaveIndex] = draftData;
      } else {
        draftsList.push(draftData);
      }
      StorageService.saveDraft(draftsList);
      this.setSuccessStatus(true, "Borrador guardado exitosamente");
    },

    onLoadSelectedDraft(draft) {
      for (const key in draft) {
        if (this.propuesta[key] || this.propuesta[key] === "") {
          this.propuesta[key] = draft[key];
        }
      }

      this.setSuccessStatus(true, "Borrador cargado correctamente");
    },

    ...mapActions("company", [
      "crearTrabajo",
      "fetchProvincia",
      "fetchDistritos"
    ]),

    ...mapActions("user", ["getCarreras"]),

    ...mapMutations("company", ["setDraftsPropuestaDialog"])
  },

  watch: {
    date1(val) {
      this.dateInit = this.formatDate(this.date1);
    },
    date2(val) {
      this.dateFin = this.formatDate(this.date2);
    },
    idiomaSelec(val) {
      this.nivelIdiomaSelec = [];
    }
  },

  async mounted() {
    if (!!!this.getListaCarreras.length) await this.getCarreras();
  }
};
</script>
